import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import { app } from "@/di";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
export default /*#__PURE__*/_defineComponent({
  __name: 'Entry',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const onClickShowLeavingPlayers = async () => {
      await app.get(GlobalResolver).startPromise(() => {
        router.push({
          name: 'players.leaving'
        });
      });
      router.push({
        name: 'staff.team.index'
      });
    };
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, _createSlots({
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'squads.formation',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.SoccerField,
            label: _ctx.$t('formation')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'squads.contracts',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.Signature20Regular,
            label: _ctx.$t('contracts')
          }, null, 8, ["to", "icon", "label"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_RouterView)]),
        _: 2
      }, [_unref(route).meta.title ? {
        name: "title",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(route).meta.title), 1)])
      } : undefined, _ctx.$debug ? {
        name: "actionButton",
        fn: _withCtx(() => [_createVNode(SimpleActionSheet, {
          ref: "simpleActionSheet",
          "no-teleport": ""
        }, {
          actions: _withCtx(() => [_createVNode(SimpleActionSheetItem, {
            class: "italic",
            "hide-on-click": "",
            onClick: onClickShowLeavingPlayers
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('show_leaving_players')), 1)]),
            _: 1
          })]),
          _: 1
        }, 512)])
      } : undefined]), 1024);
    };
  }
});